<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    @ok="videoSure"
    @cancel="close"
    cancelText="关闭">

    <a-form-item label="视频上传" :labelCol="labelCol" :wrapperCol="wrapperCol">
      <a-upload
        listType="text"
        class="avatar-uploader"
        :showUploadList="true"
        :action="uploadAction"
        :data="{'isup':1}"
        :headers="headers"
        :multiple="true"
        :beforeUpload="beforeUpload"
        @change="handleChange"
      >
        <a-button>
          <a-icon :type="uploadLoading ? 'loading' : 'upload'"/>
          点我
        </a-button>
      </a-upload>
    </a-form-item>
  </a-modal>
</template>

<script>

  export default {
    name: "eleSingleVideoSimple",
    components: {},
    props: {
      uploadParam: {
        type: Object,
      }
    },
    data() {
      return {
        title: '视频组件编辑',
        model: {},
        uploadLoading: false,
        headers: {},
        formLabelWidth: '120px',
        visible: false,
        colKey: '',
        componentFlag: '',
        labelCol: {
          xs: {span: 24},
          sm: {span: 5},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16},
        },
        filePath: {},
      }
    },
    computed: {
      uploadAction: function () {
        return this.uploadParam.fileUpload;
      }
    },
    created() {
      this.headers = {"X-Access-Token": this.uploadParam.accessToken}
    },
    methods: {
      beforeUpload: function (file) {
        var fileSize = file.size / 1024 / 1024 < 50;
        if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb',
          'video/mov'].indexOf(file.type) == -1) {
          this.$message.warning("请上传正确的视频格式");
          return false;
        }
        if (!fileSize) {
          this.$message.warning("视频大小不能超过50MB");
          return false;
        }
      },
      handleChange(info) {

        if (info.file.status === 'uploading') {
          this.uploadLoading = true;
          return
        }
        if (info.file.status === 'done') {
          let response = info.file.response;
          this.uploadLoading = false;
          if (response.success) {
            this.model.avatar = response.message;
            this.filePath = this.uploadParam.imgerver + "/" + this.model.avatar;
          } else {
            this.$message.warning(response.message);
          }
        }
      },
      getAvatarView() {
        let Url = this.uploadParam.imgerver + "/" + this.model.avatar;
        return Url;
      },
      videoSure() {
        this.visible = false;
        this.$emit('setComponentData', JSON.stringify({path: this.filePath}), this.colKey,
          this.componentFlag);
      },
      edit(colKey, componentFlag) {
        this.visible = true;
        this.colKey = colKey;
        this.componentFlag = componentFlag;
      },
      close() {
        this.visible = false;
      },
    }
  }
</script>

<style scoped>
  .avatar-uploader > .ant-upload {
    width: 104px;
    height: 104px;
  }
</style>



// WEBPACK FOOTER //
// src/lib/editMoudle/eleSingleVideoSimple.vue